import { z } from 'zod';
const number = z.union([z.string(), z.number()]).transform(v=>String(v).replace(/^\+/, '')).refine(v=>/^-?\d+(\.\d+)?$/.test(v) && Number.isFinite(Number(v)), 'Enter a finite decimal');
const whole = number.refine(v=>/^-?\d+$/.test(v), 'Enter a whole number');
const key = z.string().min(1).max(1000);
export const actionReconciliationSchema = z.object({
  confirmedTotal: whole.refine(v=>!v.startsWith('-'), 'Cannot be negative').optional(),
  adjustments: z.record(key, whole).default({}),
  costAllocations: z.array(z.object({ sourceLotKey: key, recipientLotKey: key, amount: number.refine(v=>Number(v)>0, 'Must be positive') }).strict()).max(10000).default([]),
  basisHash: z.string().regex(/^[a-f0-9]{64}$/).optional(),
}).strict();
